import {
  PATHWAY_DAY_LABEL,
  PathwayUploadReportRow,
  pathwayReasonLabel,
} from "../../types/pathway-upload.type";
import { downloadBlob } from "../Gb1SaleReport/utils";

/**
 * ค่าที่ขึ้นต้นด้วย = + - @ tab หรือ CR จะถูก Excel ตีความเป็น "สูตร" ตอนเปิดไฟล์
 * ข้อความในรายงานนี้มาจากไฟล์ที่ผู้ใช้อัปโหลด (ชื่อร้าน/ข้อความในเซลล์) จึงต้อง
 * ทำให้เป็นข้อความล้วนก่อนเสมอ ไม่งั้นคนที่เปิดรายงานโดนสูตรทำงานใส่
 * (formula injection ขาออก)
 */
const neutralizeFormula = (value: string): string =>
  /^[=+\-@\t\r]/.test(value) ? `'${value}` : value;

const escapeCell = (value: string | number | null | undefined): string => {
  if (value === null || value === undefined) return "";

  const text = neutralizeFormula(String(value));
  return `"${text.replace(/"/g, '""')}"`;
};

export const buildSkippedRowsCsv = (rows: PathwayUploadReportRow[]): string => {
  const header = ["ตำแหน่งในไฟล์", "สาย", "วัน", "ข้อความในเซลล์", "สาเหตุ"];
  const body = rows.map((row) =>
    [
      row.location,
      row.route_code ?? "",
      row.pathway_day ? PATHWAY_DAY_LABEL[row.pathway_day] : "",
      row.cell_text,
      pathwayReasonLabel(row.reason),
    ]
      .map(escapeCell)
      .join(","),
  );

  return [header.map(escapeCell).join(","), ...body].join("\r\n");
};

export const downloadSkippedRowsCsv = (
  rows: PathwayUploadReportRow[],
  fileName: string,
): void => {
  // นำหน้าด้วย BOM เพื่อให้ Excel บน Windows อ่านภาษาไทยเป็น UTF-8 ไม่เพี้ยน
  const blob = new Blob([`﻿${buildSkippedRowsCsv(rows)}`], {
    type: "text/csv;charset=utf-8;",
  });

  downloadBlob(fileName, blob);
};
